import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setMappingText } from 'src/containers/ProjectDiagram/utils/mapping/setMappingText';

export const useRenameMapping = (key?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (text) => {
      if (!diagram || !key) {
        return;
      }
      commitDiagramModel(
        diagram,
        setMappingText({
          key,
          text,
        })
      );
    },
    [diagram, key]
  );
};
